export const PRICE_PLAN_GROUP_REQUEST = 'PRICE_PLAN_GROUP_REQUEST';
export const PRICE_PLAN_GROUP_SUCCESS = 'PRICE_PLAN_GROUP_SUCCESS';
export const PRICE_PLAN_GROUP_ERROR = 'PRICE_PLAN_GROUP_ERROR';

export const PRICE_PLAN_ASSOCIATION_REQUEST = 'PRICE_PLAN_ASSOCIATION_REQUEST';
export const PRICE_PLAN_ASSOCIATION_SUCCESS = 'PRICE_PLAN_ASSOCIATION_SUCCESS';
export const PRICE_PLAN_ASSOCIATION_ERROR = 'PRICE_PLAN_ASSOCIATION_ERROR';

export const ADDON_GROUP_REQUEST = 'ADDON_GROUP_REQUEST';
export const ADDON_GROUP_SUCCESS = 'ADDON_GROUP_SUCCESS';
export const ADDON_GROUP_ERROR = 'ADDON_GROUP_ERROR';

export const EQUIPMENT_DETAILS_REQUEST = 'EQUIPMENT_DETAILS_REQUEST';
export const EQUIPMENT_DETAILS_SUCCESS = 'EQUIPMENT_DETAILS_SUCCESS';
export const EQUIPMENT_DETAILS_FAILURE = 'EQUIPMENT_DETAILS_FAILURE';

export const SERVICE_NUMBER_REQUEST = 'SERVICE_NUMBER_REQUEST';
export const SERVICE_NUMBER_SUCCESS = 'SERVICE_NUMBER_SUCCESS';
export const SERVICE_NUMBER_FAILURE = 'SERVICE_NUMBER_FAILURE';

export const DEVICE_BRANDS_REQUEST = 'DEVICE_BRANDS_REQUEST';
export const DEVICE_BRANDS_SUCCESS = 'DEVICE_BRANDS_SUCCESS';
export const DEVICE_BRANDS_ERROR = 'DEVICE_BRANDS_ERROR';

export const GET_MOBILE_SHARE_REQUEST = 'GET_MOBILE_SHARE_REQUEST';
export const GET_MOBILE_SHARE_SUCCESS = 'GET_MOBILE_SHARE_SUCCESS';
export const GET_MOBILE_SHARE_ERROR = 'GET_MOBILE_SHARE_ERROR';

export const GET_MOBILE_SHARE_ELIGIBILITY_REQUEST = 'GET_MOBILE_SHARE_ELIGIBILITY_REQUEST';
export const GET_MOBILE_SHARE_ELIGIBILITY_SUCCESS = 'GET_MOBILE_SHARE_ELIGIBILITY_SUCCESS';
export const GET_MOBILE_SHARE_ELIGIBILITY_ERROR = 'GET_MOBILE_SHARE_ELIGIBILITY_ERROR';

export const GET_DEVICES_BY_PLAN_GROUP_REQUEST = 'GET_DEVICES_BY_PLAN_GROUP_REQUEST';
export const GET_DEVICES_BY_PLAN_GROUP_SUCCESS = 'GET_DEVICES_BY_PLAN_GROUP_SUCCESS';
export const GET_DEVICES_BY_PLAN_GROUP_ERROR = 'GET_DEVICES_BY_PLAN_GROUP_ERROR';

export const GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST = 'GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST';
export const GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS = 'GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS';
export const GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE = 'GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE';

export const GET_SMART_TEMPLATE_MENU_REQUEST = 'GET_SMART_TEMPLATE_MENU_REQUEST';
export const GET_SMART_TEMPLATE_MENU_SUCCESS = 'GET_SMART_TEMPLATE_MENU_SUCCESS';
export const GET_SMART_TEMPLATE_MENU_FAILURE = 'GET_SMART_TEMPLATE_MENU_FAILURE';

export const UPDATE_SMART_TEMPLATE_NAME_REQUEST = 'UPDATE_SMART_TEMPLATE_NAME_REQUEST';
export const UPDATE_SMART_TEMPLATE_NAME_SUCCESS = 'UPDATE_SMART_TEMPLATE_NAME_SUCCESS';
export const UPDATE_SMART_TEMPLATE_NAME_FAILURE = 'UPDATE_SMART_TEMPLATE_NAME_FAILURE';

export const DELETE_SMART_TEMPLATE_REQUEST = 'DELETE_SMART_TEMPLATE_REQUEST';
export const DELETE_SMART_TEMPLATE_SUCCESS = 'DELETE_SMART_TEMPLATE_SUCCESS';
export const DELETE_SMART_TEMPLATE_FAILURE = 'DELETE_SMART_TEMPLATE_FAILURE';

export const GET_CHECK_RESERVE_REQUEST = 'GET_CHECK_RESERVE_REQUEST';
export const GET_CHECK_RESERVE_SUCCESS = 'GET_CHECK_RESERVE_SUCCESS';
export const GET_CHECK_RESERVE_FAILURE = 'GET_CHECK_RESERVE_FAILURE';

export const GET_RESERVED_STOCKS_REQUEST = 'GET_RESERVED_STOCKS_REQUEST';
export const GET_RESERVED_STOCKS_SUCCESS = 'GET_RESERVED_STOCKS_SUCCESS';
export const GET_RESERVED_STOCKS_FAILURE = 'GET_RESERVED_STOCKS_FAILURE';

export const GET_SMART_TEMPLATE_BY_ID_REQUEST = 'GET_SMART_TEMPLATE_BY_ID_REQUEST';
export const GET_SMART_TEMPLATE_BY_ID_SUCCESS = 'GET_SMART_TEMPLATE_BY_ID_SUCCESS';
export const GET_SMART_TEMPLATE_BY_ID_FAILURE = 'GET_SMART_TEMPLATE_BY_ID_FAILURE';

export const GET_NUMBER_POOL_BILL_ACC_REQUEST = 'GET_NUMBER_POOL_BILL_ACC_REQUEST';
export const GET_NUMBER_POOL_BILL_ACC_SUCCESS = 'GET_NUMBER_POOL_BILL_ACC_SUCCESS';
export const GET_NUMBER_POOL_BILL_ACC_FAILURE = 'GET_NUMBER_POOL_BILL_ACC_FAILURE';

export const GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST = 'GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST';
export const GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS = 'GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS';
export const GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE = 'GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE';

export const GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT = 'GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT';

export const GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST = 'GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST';
export const GET_BUNDLEDADDONS_FOR_PRICEPLAN_SUCCESS = 'GET_BUNDLEDADDONS_FOR_PRICEPLAN_SUCCESS';
export const GET_BUNDLEDADDONS_FOR_PRICEPLAN_ERROR = 'GET_BUNDLEDADDONS_FOR_PRICEPLAN_ERROR';

export const SELECTED_PLAN = 'SELECTED_PLAN';


export const GET_DEP_RESELLER_ID_REQUEST = "GET_DEP_RESELLER_ID_REQUEST";
export const GET_DEP_RESELLER_ID_SUCCESS = "GET_DEP_RESELLER_ID_SUCCESS";
export const GET_DEP_RESELLER_ID_ERROR = "GET_DEP_RESELLER_ID_ERROR";

